<app-data-table [columns]="columns" [data]="agentsTable()" [filters]="filters" [totalRecords]="totalRecords()"
  [cardTemplate]="card" (add)="onAdd()" (pageChange)="onPage($event)" (edit)="onEdit($event)"
  (removeSelected)="onRemoveSelected($event)" (search)="onSearch($event)" />

<ng-template #card let-agent>
  <div class="surface-card shadow-2 p-3 border-round h-full flex flex-column">
    <div class="flex align-items-center justify-content-between mb-3">
      <div class="flex align-items-center">
        <div
          class="flex align-items-center justify-content-center bg-blue-100 text-blue-500 border-circle w-3rem h-3rem font-bold text-xl mr-2">
          {{ agent.name.charAt(0).toUpperCase() }}
        </div>
        <div>
          <div class="font-bold text-900">{{ agent.name }}</div>
          <div class="text-500 text-sm">{{ agent.city || 'Sin ciudad' }}</div>
        </div>
      </div>
      <p-button icon="pi pi-ellipsis-v" [text]="true" [rounded]="true" severity="secondary"
        (onClick)="onEdit(agent)"></p-button>
    </div>

    <div class="flex flex-column gap-2 mt-auto">
      <div class="flex align-items-center gap-2 text-700">
        <i class="pi pi-envelope text-500"></i>
        <span class="white-space-nowrap overflow-hidden text-overflow-ellipsis">{{ agent.email }}</span>
      </div>
      <div class="flex align-items-center gap-2 text-700">
        <i class="pi pi-phone text-500"></i>
        <span>{{ agent.phone }}</span>
      </div>
    </div>

    <div class="flex gap-2 mt-3 pt-3 border-top-1 surface-border">
      <a pButton class="flex-1 p-button-outlined p-button-sm justify-content-center no-underline"
        href="mailto:{{agent.email}}">
        <i class="pi pi-envelope mr-2"></i> Email
      </a>
      <a pButton class="flex-1 p-button-outlined p-button-sm justify-content-center no-underline"
        href="tel:{{agent.phone}}">
        <i class="pi pi-phone mr-2"></i> Llamar
      </a>
    </div>
  </div>
</ng-template>

<app-add-agent [(visible)]="dialogVisible" (save)="onSave($event)" />